import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PopupCloseButton({ onClick, className = '' }) {
  const { t } = useTranslation();
  return (
    <button type="button" className={`popup-close-button ${className}`}
      aria-label={t('editSltp.close')} onMouseDown={(event) => event.stopPropagation()} onClick={onClick}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
        <path d="m6 6 12 12M18 6 6 18" />
      </svg>
    </button>
  );
}
